<div class="text-center position-abslrt" *ngIf="enableSpinner">
    <div class="spinner-border text-danger" role="status">
    </div>
</div>
<app-header></app-header>
<router-outlet></router-outlet>
<app-footer></app-footer>